import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function ExplorerTransection() {
    const [idNumber, setIdNumber] = useState("");
    const [data, setData] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const fetchUserData = async () => {
        setError("");
        setData([]);
        setLoading(true);
        try {
            const response = await fetch(`https://crypto-co.nugenesisou.com/explorer/user?to_address=${idNumber}`);
            const result = await response.json();

            if (response.ok) {
                setData(result);
            } else {
                setError(result.detail || "User not found");
            }
        } catch (err) {
            setError("❌ Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <main style={{ backgroundColor: "#0A0A0A", color: "#fff", minHeight: "100vh", fontFamily: "Orbitron, sans-serif" }}>
                <section style={{ padding: "115px 20px", textAlign: "center" }}>
                    <h1 style={{ fontSize: "3rem", color: "#00E5FF", marginBottom: "0.5rem" }}>SEARCH</h1>
                    <h2 style={{ fontSize: "2rem", color: "#ffffff", marginBottom: "2rem" }}>NuCoin 1 Explorer History</h2>

                    <div style={{ maxWidth: "500px", margin: "0 auto", display: "flex", gap: "10px", flexDirection: "column" }}>
                        <input
                            type="text"
                            placeholder="Enter Wallet ID "
                            value={idNumber}
                            onChange={(e) => setIdNumber(e.target.value)}
                            style={{
                                padding: "12px",
                                borderRadius: "8px",
                                border: "1px solid #444",
                                backgroundColor: "#1a1a1a",
                                color: "#fff",
                                fontSize: "1rem"
                            }}
                        />
                        <button
                            onClick={fetchUserData}
                            style={{
                                padding: "12px",
                                borderRadius: "8px",
                                border: "none",
                                backgroundColor: "#00E5FF",
                                color: "#000",
                                fontWeight: "bold",
                                cursor: "pointer",
                                fontSize: "1rem"
                            }}
                        >
                            Search
                        </button>
                        {loading && (
                            <div style={{ marginTop: "20px" }}>
                                <div className="spinner" />
                            </div>
                        )}
                        {error && !loading && (
                            <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
                        )}
                    </div>
                </section>

                {data.length > 0 && (
                    <section style={{ padding: "20px" }}>
                        <div style={{
                            maxWidth: "100%",
                            margin: "0 auto",
                            overflowX: "auto",
                            backgroundColor: "#121212",
                            padding: "20px",
                            borderRadius: "12px"
                        }}>
                            <div style={{ minWidth: "900px" }}>
                                <h3 style={{ marginBottom: "20px", color: "#00E5FF", textAlign: "center" }}>Transaction Results</h3>
                                <table style={{ width: "100%", borderCollapse: "collapse", color: "#fff" }}>
                                    <thead>
                                        <tr>
                                            {Object.keys(data[0])
                                                .filter(key => ![
                                                    "user_name",
                                                    "first_name",
                                                    "middle_name",
                                                    "last_name",
                                                    "mobile_number",
                                                    "email"
                                                ].includes(key))
                                                .map((key) => {
                                                    const formattedKey = key
                                                        .replace(/_/g, " ")
                                                        .replace(/\b\w/g, (c) => c.toUpperCase());
                                                    return (
                                                        <th
                                                            key={key}
                                                            style={{
                                                                padding: "12px",
                                                                borderBottom: "1px solid #333",
                                                                textAlign: "left",
                                                                backgroundColor: "#1F1F1F"
                                                            }}
                                                        >
                                                            {formattedKey}
                                                        </th>
                                                    );
                                                })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((row, index) => (
                                            <tr key={index}>
                                                {Object.entries(row)
                                                    .filter(([key]) => ![
                                                        "user_name",
                                                        "first_name",
                                                        "middle_name",
                                                        "last_name",
                                                        "mobile_number",
                                                        "email"
                                                    ].includes(key))
                                                    .map(([_, value], idx) => (
                                                        <td
                                                            key={idx}
                                                            style={{
                                                                padding: "12px",
                                                                borderBottom: "1px solid #222",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                maxWidth: "200px"
                                                            }}
                                                        >
                                                            <span title={value}>
                                                                {value !== null ? value.toString() : "—"}
                                                            </span>
                                                        </td>
                                                    ))}
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </section>
                )}
            </main>
            <Footer />

            {/* Spinner CSS */}
            <style>
                {`
                .spinner {
                    margin: 0 auto;
                    width: 40px;
                    height: 40px;
                    border: 4px solid rgba(0, 229, 255, 0.3);
                    border-top: 4px solid #00E5FF;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                }

                @keyframes spin {
                    to {
                        transform: rotate(360deg);
                    }
                }
            `}
            </style>
        </>
    );
}
